<div class="component-container" fxFlex fxLayout="column">
  <div class="form-container" [formGroup]="getPractitionerForm()" [style.pointer-events]="hasAccessToEditPractitioner() ? '' : 'none'" fxFlex fxLayout="column">
    <mat-form-field fxFlex>
      <mat-label>Nome</mat-label>
      <input matInput type="text" formControlName="name" required />
    </mat-form-field>
    <div fxFlex>
      <mat-form-field fxFlex="33">
        <mat-label>UF</mat-label>
        <mat-select formControlName="stateAcronym" required>
          <mat-option *ngFor="let state of getStates()" [value]="state">{{ state.getValue() }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field fxFlex="33">
        <mat-label>CRM</mat-label>
        <input matInput type="text" formControlName="registration" required />
      </mat-form-field>
      <mat-form-field fxFlex="33">
        <mat-label>Situação</mat-label>
        <mat-select formControlName="status" required>
          <mat-option *ngFor="let status of getPractitionerStatusList()" [value]="status">{{ status.getDescription() }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div *ngIf="hasAccessToEditPractitioner()" fxFlex fxLayoutAlign="start center" fxLayoutGap="10px">
      <auto-complete-search
        id="productAutoComplete"
        appearance="outline"
        [width]="450"
        [searchProvider]="autoCompleteProvider"
        [placeholder]="'Especialização'"
        (valueChange)="getAutoCompleteValue($event)"></auto-complete-search>

      <button mat-flat-button class="add-btn" (click)="addSpecialty()">ADICIONAR</button>
    </div>
    <div fxFlex>
      <mat-chip-listbox>
        <mat-chip-option *ngFor="let specialty of getSpecialties()">
          {{ specialty.getDescription() }}
          <mat-icon matChipRemove (click)="deleteSpecialty(specialty)">cancel</mat-icon>
        </mat-chip-option>
      </mat-chip-listbox>
    </div>
  </div>
  <div class="btn-container" fxFlex>
    <button mat-flat-button class="back-btn" (click)="goToSearchPractitioner()">VOLTAR</button>
    <button *ngIf="hasAccessToEditPractitioner()" mat-flat-button class="register-btn" (click)="editPractitioner()">SALVAR ALTERAÇÕES</button>
  </div>
</div>
